// extracted by mini-css-extract-plugin
export default {"button":"PostActionButton-module__button--epd83","animatedBackground":"PostActionButton-module__animatedBackground--0yhQN"};